import { useState } from "react";
import { siteImages } from "../../content/website";

interface PhotoProps {
  /** Posición de la imagen en siteImages (src/content/website.ts). */
  index: number;
  className?: string;
  /** Ancho que ocupa en pantalla, para que el navegador elija bien (atributo sizes). */
  sizes?: string;
  /** La imagen principal se carga de inmediato; el resto, al acercarse a la pantalla. */
  priority?: boolean;
}

/**
 * Fotografía con carga diferida, dimensiones reservadas (evita saltos de diseño) y una alternativa legible si el
 * proveedor deja de servirla o si quitaste esa imagen en WebForge. Los créditos se muestran en el pie de página.
 */
export function Photo({ index, className, sizes = "100vw", priority = false }: PhotoProps) {
  const image = siteImages[index];
  const [failed, setFailed] = useState("");
  if (!image || failed === image.source) {
    return <div className={`ix-photo ix-photo--empty ${className ?? ""}`} role="img" aria-label={image?.alt ?? "Espacio para una fotografía"}>
      <span>{image?.alt ?? "Agrega una fotografía"}</span>
    </div>;
  }
  return <img
    className={`ix-photo ${className ?? ""}`}
    src={image.source}
    alt={image.alt}
    width={image.width || undefined}
    height={image.height || undefined}
    sizes={sizes}
    loading={priority ? "eager" : "lazy"}
    fetchPriority={priority ? "high" : "auto"}
    decoding="async"
    onError={() => setFailed(image.source)}
  />;
}
